import { useRouter } from 'next/router'
import React from 'react'
import { useEffect } from 'react'

// TODO: router.events is deprecated in nextjs v13, perhaps use nextjs-toploader instead?
export function useLoadingState() {
  const router = useRouter()

  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {
    const handleStart = () => setIsLoading(true)
    const handleStop = () => setIsLoading(false)

    router.events.on('routeChangeStart', handleStart)
    router.events.on('routeChangeComplete', handleStop)
    router.events.on('routeChangeError', handleStop)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      router.events.off('routeChangeComplete', handleStop)
      router.events.off('routeChangeError', handleStop)
    }
  }, [router])

  return { isLoading }
}
